import { DatePickerRangeProps } from './date-picker-range.props';

export const DatePickerRangePresets: DatePickerRangeProps = {
  allowFutureDates: true,
  anchor: 'right',
  displayFormat: 'MM/DD/YYYY',
};
